import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: File;
};

export type Admin = {
  __typename?: 'Admin';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  enable: Scalars['Boolean'];
  fullName: Scalars['String'];
  id: Scalars['String'];
  role: AdminRole;
  tokenVersion: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type AdminLoginOtpResponse = {
  __typename?: 'AdminLoginOTPResponse';
  data: Admin;
  token: Scalars['String'];
};

export type AdminMessageListResponse = {
  __typename?: 'AdminMessageListResponse';
  messageList: Array<Message>;
  totalCount: Scalars['Float'];
};

export type AdminPartnersListResponse = {
  __typename?: 'AdminPartnersListResponse';
  partnerList: Array<AffiliatePartner>;
  totalCount: Scalars['Float'];
};

export type AdminPatientCountResponse = {
  __typename?: 'AdminPatientCountResponse';
  activePatientsCount: Scalars['Float'];
  expiredPatientsCount: Scalars['Float'];
  pendingPatientsCount: Scalars['Float'];
  totalCount: Scalars['Float'];
};

export type AdminPatientHistoricalPlanResponse = {
  __typename?: 'AdminPatientHistoricalPlanResponse';
  created_at: Scalars['DateTime'];
  end_date?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  patientId: Scalars['String'];
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['String']>;
  plan?: Maybe<PaymentPlan>;
  planId: Scalars['String'];
  receiptUrl?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PatientPlanStatus>;
  stripeSubscriptionId: Scalars['String'];
};

export type AdminPatientListItem = {
  __typename?: 'AdminPatientListItem';
  _count?: Maybe<PatientCount>;
  address: Scalars['String'];
  automaticRenewal: Scalars['Boolean'];
  birthDate?: Maybe<Scalars['DateTime']>;
  children?: Maybe<Scalars['JSON']>;
  city: Scalars['String'];
  comments: Scalars['String'];
  created_at: Scalars['DateTime'];
  email: Scalars['String'];
  emailLower: Scalars['String'];
  enable: Scalars['Boolean'];
  expires_at?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  firstNameLower: Scalars['String'];
  id: Scalars['String'];
  idCardNumber?: Maybe<Scalars['String']>;
  idCardNumberNum?: Maybe<Scalars['Int']>;
  isMasterPatient: Scalars['Boolean'];
  isOnBoardEmailSent: Scalars['Boolean'];
  lastName: Scalars['String'];
  lastNameLower: Scalars['String'];
  manualStartDate?: Maybe<Scalars['DateTime']>;
  newsOffersNotification: Scalars['Boolean'];
  oldIdCardNumber?: Maybe<Scalars['String']>;
  oldPatientId?: Maybe<Scalars['String']>;
  oldProviderId?: Maybe<Scalars['String']>;
  originalStatus?: Maybe<Scalars['String']>;
  patientStripeId: Scalars['String'];
  paymentMethodUpdates?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  primaryContactNo: Scalars['String'];
  providerId?: Maybe<Scalars['String']>;
  providerRef: Scalars['String'];
  referralCode?: Maybe<Scalars['String']>;
  renewalNotification: RenewalNotificationType;
  secondaryContactNo: Scalars['String'];
  spouse?: Maybe<Scalars['JSON']>;
  state: Scalars['String'];
  status?: Maybe<PatientStatus>;
  tokenVersion: Scalars['Int'];
  type: PatientType;
  updated_at: Scalars['DateTime'];
};

export type AdminPatientListResponse = {
  __typename?: 'AdminPatientListResponse';
  patientList: Array<AdminPatientListItem>;
  totalCount: Scalars['Float'];
};

export type AdminPatientPlanResponse = {
  __typename?: 'AdminPatientPlanResponse';
  created_at: Scalars['DateTime'];
  end_date?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  patientId: Scalars['String'];
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['String']>;
  plan?: Maybe<PaymentPlan>;
  planId: Scalars['String'];
  start_date?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PatientPlanStatus>;
  stripeSubscriptionId: Scalars['String'];
};

export type AdminProviderListResponse = {
  __typename?: 'AdminProviderListResponse';
  providerList: Array<Provider>;
  totalCount: Scalars['Float'];
};

export type AdminProviderResponse = {
  __typename?: 'AdminProviderResponse';
  _count?: Maybe<ProviderCount>;
  birthDate?: Maybe<Scalars['DateTime']>;
  chiropractors: Array<Doctor>;
  city: Scalars['String'];
  clinicAddress: Scalars['String'];
  comments: Scalars['String'];
  contactName: Scalars['String'];
  created_at: Scalars['DateTime'];
  doctorLocatorEnable: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  enable: Scalars['Boolean'];
  enrollmentType: ProviderEnrollmentType;
  fax: Scalars['String'];
  firstname: Scalars['String'];
  googleMapPlaceId: Scalars['String'];
  id: Scalars['String'];
  lastname: Scalars['String'];
  limitsOfLiability: Scalars['String'];
  mailAddress: Scalars['String'];
  mailCity: Scalars['String'];
  mailPostalCode: Scalars['String'];
  mailState: Scalars['String'];
  malpracticeInsuranceNumber: Scalars['String'];
  noPatientRenewal: Scalars['Boolean'];
  officeHours: Scalars['String'];
  oldMemberNumber?: Maybe<Scalars['String']>;
  oldProviderId: Scalars['String'];
  onBoardReferralCode: Scalars['String'];
  onReferralName: Scalars['String'];
  phoneNumber: Scalars['String'];
  postalCode: Scalars['String'];
  practiceName: Scalars['String'];
  practiceNameLower: Scalars['String'];
  promoCode: Scalars['String'];
  providerId: Scalars['String'];
  providerIdNum?: Maybe<Scalars['Int']>;
  socialMediaHandles: Array<SocialMedia>;
  staffEmail: Scalars['String'];
  state: Scalars['String'];
  stateLicenseNumber: Scalars['String'];
  status?: Maybe<ProviderStatus>;
  taxIDNumber: Scalars['String'];
  tokenVersion: Scalars['Int'];
  updated_at: Scalars['DateTime'];
  website: Scalars['String'];
};

export type AdminReportListResponse = {
  __typename?: 'AdminReportListResponse';
  reportList: Array<Report>;
  totalCount: Scalars['Float'];
};

export enum AdminRole {
  Bot = 'BOT',
  Master = 'MASTER',
  Member = 'MEMBER'
}

export type AdminSingleProviderResponse = {
  __typename?: 'AdminSingleProviderResponse';
  _count?: Maybe<ProviderCount>;
  activeP: Scalars['Float'];
  birthDate?: Maybe<Scalars['DateTime']>;
  chiropractors: Array<Doctor>;
  city: Scalars['String'];
  clinicAddress: Scalars['String'];
  comments: Scalars['String'];
  contactName: Scalars['String'];
  created_at: Scalars['DateTime'];
  doctorLocatorEnable: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  enable: Scalars['Boolean'];
  enrollmentType: ProviderEnrollmentType;
  expiredP: Scalars['Float'];
  fax: Scalars['String'];
  firstname: Scalars['String'];
  googleMapPlaceId: Scalars['String'];
  id: Scalars['String'];
  lastname: Scalars['String'];
  limitsOfLiability: Scalars['String'];
  mailAddress: Scalars['String'];
  mailCity: Scalars['String'];
  mailPostalCode: Scalars['String'];
  mailState: Scalars['String'];
  malpracticeInsuranceNumber: Scalars['String'];
  noPatientRenewal: Scalars['Boolean'];
  officeHours: Scalars['String'];
  oldMemberNumber?: Maybe<Scalars['String']>;
  oldProviderId: Scalars['String'];
  onBoardReferralCode: Scalars['String'];
  onReferralName: Scalars['String'];
  pendingP: Scalars['Float'];
  phoneNumber: Scalars['String'];
  postalCode: Scalars['String'];
  practiceName: Scalars['String'];
  practiceNameLower: Scalars['String'];
  promoCode: Scalars['String'];
  providerId: Scalars['String'];
  providerIdNum?: Maybe<Scalars['Int']>;
  socialMediaHandles: Array<SocialMedia>;
  staffEmail: Scalars['String'];
  state: Scalars['String'];
  stateLicenseNumber: Scalars['String'];
  status?: Maybe<ProviderStatus>;
  taxIDNumber: Scalars['String'];
  tokenVersion: Scalars['Int'];
  totalP: Scalars['Float'];
  updated_at: Scalars['DateTime'];
  website: Scalars['String'];
};

export type AdminUpdateDoctorOfProviderInput = {
  additionalComments?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['DateTime']>;
  certificates?: InputMaybe<Scalars['String']>;
  colleges?: InputMaybe<Scalars['String']>;
  diagnostics?: InputMaybe<Scalars['String']>;
  doYouOffer?: InputMaybe<Scalars['String']>;
  fees?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  hours?: InputMaybe<Scalars['String']>;
  modalities?: InputMaybe<Scalars['String']>;
  techniques?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type AdminUpdateProviderInput = {
  city?: InputMaybe<Scalars['String']>;
  clinicAddress?: InputMaybe<Scalars['String']>;
  doctorLocatorEnable?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  enable?: InputMaybe<Scalars['Boolean']>;
  enrollmentType?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  googleMapPlaceId?: InputMaybe<Scalars['String']>;
  limitsOfLiability?: InputMaybe<Scalars['String']>;
  mailAddress?: InputMaybe<Scalars['String']>;
  mailCity?: InputMaybe<Scalars['String']>;
  mailPostalCode?: InputMaybe<Scalars['String']>;
  mailState?: InputMaybe<Scalars['String']>;
  malpracticeInsuranceNumber?: InputMaybe<Scalars['String']>;
  noPatientRenewal?: InputMaybe<Scalars['Boolean']>;
  officeHours?: InputMaybe<Scalars['String']>;
  onBoardReferralCode?: InputMaybe<Scalars['String']>;
  onReferralName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  practiceName?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<Scalars['String']>;
  socialMediaHandles?: InputMaybe<Array<SocialMediaInput>>;
  staffEmail?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  stateLicenseNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  taxIDNumber?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type AffiliatePartner = {
  __typename?: 'AffiliatePartner';
  _count?: Maybe<AffiliatePartnerCount>;
  address: Scalars['String'];
  agent: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  bankACNumber: Scalars['String'];
  bankRoutingNumber: Scalars['String'];
  city: Scalars['String'];
  companyName: Scalars['String'];
  created_at: Scalars['DateTime'];
  currentNoOfEmployees: Scalars['Int'];
  email: Scalars['String'];
  enable: Scalars['Boolean'];
  id: Scalars['String'];
  isApproved: Scalars['Boolean'];
  logo: Scalars['String'];
  phoneNumber: Scalars['String'];
  planPurchase: Scalars['String'];
  postalCode: Scalars['String'];
  referralCode: Scalars['String'];
  state: Scalars['String'];
  status: AffiliatePartnerStatus;
  tapfiliateId?: Maybe<Scalars['String']>;
  type: AffiliatePartnerType;
  updated_at: Scalars['DateTime'];
  w9Form: Scalars['String'];
  website: Scalars['String'];
};

export type AffiliatePartnerCount = {
  __typename?: 'AffiliatePartnerCount';
  ContactLog: Scalars['Int'];
};

export enum AffiliatePartnerStatus {
  Approved = 'APPROVED',
  InReview = 'IN_REVIEW'
}

export enum AffiliatePartnerType {
  Ambassador = 'AMBASSADOR',
  CorporatePartnership = 'CORPORATE_PARTNERSHIP',
  StateAssociation = 'STATE_ASSOCIATION'
}

export type ContactLog = {
  __typename?: 'ContactLog';
  comments: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by: Scalars['String'];
  description: Scalars['String'];
  filepath: Scalars['String'];
  id: Scalars['String'];
  partnerId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  updated_by: Scalars['String'];
};

export type Doctor = {
  __typename?: 'Doctor';
  additionalComments: Scalars['String'];
  birthDate?: Maybe<Scalars['DateTime']>;
  certificates?: Maybe<Scalars['String']>;
  colleges?: Maybe<Scalars['String']>;
  diagnostics?: Maybe<Scalars['String']>;
  doYouOffer?: Maybe<Scalars['String']>;
  fees?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  hours?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  modalities?: Maybe<Scalars['String']>;
  oldProviderId: Scalars['String'];
  providerId: Scalars['String'];
  techniques?: Maybe<Scalars['String']>;
  website: Scalars['String'];
};

export type DoctorLocatorProviderFullRes = {
  __typename?: 'DoctorLocatorProviderFullRes';
  _count?: Maybe<ProviderCount>;
  birthDate?: Maybe<Scalars['DateTime']>;
  chiropractors: Array<Doctor>;
  city: Scalars['String'];
  clinicAddress: Scalars['String'];
  comments: Scalars['String'];
  contactName: Scalars['String'];
  created_at: Scalars['DateTime'];
  doctorLocatorEnable: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  enable: Scalars['Boolean'];
  enrollmentType: ProviderEnrollmentType;
  fax: Scalars['String'];
  firstname: Scalars['String'];
  googleMapPlaceId: Scalars['String'];
  id: Scalars['String'];
  lastname: Scalars['String'];
  limitsOfLiability: Scalars['String'];
  mailAddress: Scalars['String'];
  mailCity: Scalars['String'];
  mailPostalCode: Scalars['String'];
  mailState: Scalars['String'];
  malpracticeInsuranceNumber: Scalars['String'];
  noPatientRenewal: Scalars['Boolean'];
  officeHours: Scalars['String'];
  oldMemberNumber?: Maybe<Scalars['String']>;
  oldProviderId: Scalars['String'];
  onBoardReferralCode: Scalars['String'];
  onReferralName: Scalars['String'];
  phoneNumber: Scalars['String'];
  postalCode: Scalars['String'];
  practiceName: Scalars['String'];
  practiceNameLower: Scalars['String'];
  promoCode: Scalars['String'];
  providerId: Scalars['String'];
  providerIdNum?: Maybe<Scalars['Int']>;
  socialMediaHandles: Array<SocialMedia>;
  staffEmail: Scalars['String'];
  state: Scalars['String'];
  stateLicenseNumber: Scalars['String'];
  status?: Maybe<ProviderStatus>;
  taxIDNumber: Scalars['String'];
  tokenVersion: Scalars['Int'];
  updated_at: Scalars['DateTime'];
  website: Scalars['String'];
};

export type DoctorLocatorProviderListResponse = {
  __typename?: 'DoctorLocatorProviderListResponse';
  distance?: Maybe<Scalars['Float']>;
  provider: Provider;
};

export type DoctorType = {
  birthDate?: InputMaybe<Scalars['DateTime']>;
  fullName?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
};

export type MemberCardInfoResponse = {
  __typename?: 'MemberCardInfoResponse';
  autoRenewal?: Maybe<Scalars['String']>;
  birthDate: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  idCardNumber: Scalars['String'];
  lastName: Scalars['String'];
  planName?: Maybe<Scalars['String']>;
  providerId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
};

export type Message = {
  __typename?: 'Message';
  created_at: Scalars['DateTime'];
  id: Scalars['String'];
  message: Scalars['String'];
  messageType: MessageType;
  receipient: MessageReceipientType;
  title: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export enum MessageReceipientType {
  All = 'ALL',
  Patients = 'PATIENTS',
  Providers = 'PROVIDERS'
}

export enum MessageType {
  PcdMessage = 'PCD_MESSAGE',
  PlanMessage = 'PLAN_MESSAGE'
}

export type Mutation = {
  __typename?: 'Mutation';
  adminAddAnnouncement: Message;
  adminAddPartnerContactLog: Array<ContactLog>;
  adminAddPatient: Scalars['String'];
  adminAddPatientContactLog: Array<ContactLog>;
  adminAddProviderContactLog: Array<ContactLog>;
  adminApprovePartner: Scalars['Boolean'];
  adminChangeMemberActiveState: Scalars['Boolean'];
  adminChangePartnerState: Scalars['Boolean'];
  adminChangePatientEmail: Patient;
  adminChangePatientProvider: Provider;
  adminCreate: Scalars['Boolean'];
  adminCreateEmptyDoctorOnProvider: Doctor;
  adminCreatePromoCode: PromoCode;
  adminDeleteAnnouncement: Scalars['Boolean'];
  adminInviteMember: Scalars['Boolean'];
  adminListDoctorsOfProvider: Array<Doctor>;
  adminLogin: Scalars['Boolean'];
  adminLoginWithOTP: AdminLoginOtpResponse;
  adminMeUpdateName: Scalars['Boolean'];
  adminPatientCancelPlan: Scalars['Boolean'];
  adminResendLoginOTP: Scalars['Boolean'];
  adminUpdatPartner: AffiliatePartner;
  adminUpdateAnnouncement: Message;
  adminUpdateDoctorOnProvider: Doctor;
  adminUpdatePartnerContactLog: Array<ContactLog>;
  adminUpdatePatient: Scalars['String'];
  adminUpdatePatientContactLog: Array<ContactLog>;
  adminUpdatePromoCode: PromoCode;
  adminUpdateProvider: AdminProviderResponse;
  adminUpdateProviderContactLog: Array<ContactLog>;
  changeMyProvider: Provider;
  getActivityReport: Scalars['Boolean'];
  getDepositReport: Scalars['Boolean'];
  getPaymentLinkForAdmin: Scalars['String'];
  getPublicPaymentLink: Scalars['String'];
  getReportViewAction: Array<Scalars['String']>;
  partnerSignUp: Scalars['Boolean'];
  patieentUpdatePaperRenewalNotificationState: Scalars['Boolean'];
  patientBulkUpload: Array<Scalars['String']>;
  patientCancelPlan: Scalars['Boolean'];
  patientCancelPlanMessage: Scalars['String'];
  patientChangeEmail: Patient;
  patientLogin: Scalars['String'];
  patientLoginWithOTP: PatientLoginOtpResponse;
  patientRecoverAccount: Scalars['Boolean'];
  patientResendLoginOTP: Scalars['String'];
  patientSignup: Scalars['String'];
  patientTurnOnAutomaticRenewal: Scalars['Boolean'];
  patientUpdateNewsOfferState: Scalars['Boolean'];
  patientUpdateProfile: Patient;
  patientVerifyOTP: Scalars['Boolean'];
  providerCreateEmptyDoctor: Doctor;
  providerDeactivateProfile: Scalars['Boolean'];
  providerLogin: Scalars['String'];
  providerLoginWithOTP: ProviderLoginOtpResponse;
  providerRecoverAccount: Scalars['Boolean'];
  providerResendLoginOTP: Scalars['String'];
  providerSignup: Scalars['String'];
  providerUpdateAssociateProfile: Doctor;
  providerUpdateDetails: Provider;
  publicSubscribeToPlan: SubsribeToPlanResponse;
  publicSubscribeToPlanWithToken: PublicSubsribeToPlanResponse;
  publicVerifyPayment: Scalars['Boolean'];
  publicVerifyPaymentWithToken: Scalars['Boolean'];
};


export type MutationAdminAddAnnouncementArgs = {
  message: Scalars['String'];
  messageType: Scalars['String'];
  receipientType: Scalars['String'];
  title: Scalars['String'];
};


export type MutationAdminAddPartnerContactLogArgs = {
  comment?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
  partnerId: Scalars['String'];
};


export type MutationAdminAddPatientArgs = {
  address: Scalars['String'];
  birthDate: Scalars['DateTime'];
  children?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  comments?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  newsOffersNotification: Scalars['Boolean'];
  postalCode: Scalars['String'];
  primaryContactNo: Scalars['String'];
  providerId: Scalars['String'];
  renewalNotification: Scalars['String'];
  secondaryContactNo?: InputMaybe<Scalars['String']>;
  spouse?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  type: Scalars['String'];
};


export type MutationAdminAddPatientContactLogArgs = {
  comment?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
  patientId: Scalars['String'];
};


export type MutationAdminAddProviderContactLogArgs = {
  comment?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
  providerId: Scalars['String'];
};


export type MutationAdminApprovePartnerArgs = {
  isApproved: Scalars['Boolean'];
  partnerId: Scalars['String'];
};


export type MutationAdminChangeMemberActiveStateArgs = {
  adminId: Scalars['String'];
  status: Scalars['Boolean'];
};


export type MutationAdminChangePartnerStateArgs = {
  partnerId: Scalars['String'];
  state: Scalars['Boolean'];
};


export type MutationAdminChangePatientEmailArgs = {
  newEmail: Scalars['String'];
  patientId: Scalars['String'];
};


export type MutationAdminChangePatientProviderArgs = {
  newProviderId: Scalars['String'];
  patientId: Scalars['String'];
};


export type MutationAdminCreateArgs = {
  email: Scalars['String'];
  name: Scalars['String'];
  role: Scalars['String'];
};


export type MutationAdminCreateEmptyDoctorOnProviderArgs = {
  providerId: Scalars['String'];
};


export type MutationAdminCreatePromoCodeArgs = {
  amount?: InputMaybe<Scalars['Float']>;
  code: Scalars['String'];
  days?: InputMaybe<Scalars['Float']>;
  discountType: Scalars['String'];
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Float']>;
  note?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type MutationAdminDeleteAnnouncementArgs = {
  id: Scalars['String'];
};


export type MutationAdminInviteMemberArgs = {
  email: Scalars['String'];
  fullName: Scalars['String'];
};


export type MutationAdminListDoctorsOfProviderArgs = {
  providerId: Scalars['String'];
};


export type MutationAdminLoginArgs = {
  email: Scalars['String'];
};


export type MutationAdminLoginWithOtpArgs = {
  email: Scalars['String'];
  otp: Scalars['String'];
};


export type MutationAdminMeUpdateNameArgs = {
  name: Scalars['String'];
};


export type MutationAdminPatientCancelPlanArgs = {
  needRefund?: InputMaybe<Scalars['Boolean']>;
  subscriptionId: Scalars['String'];
};


export type MutationAdminResendLoginOtpArgs = {
  email: Scalars['String'];
};


export type MutationAdminUpdatPartnerArgs = {
  companyName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  partnerId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type MutationAdminUpdateAnnouncementArgs = {
  id: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<Scalars['String']>;
  receipientType?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationAdminUpdateDoctorOnProviderArgs = {
  data: AdminUpdateDoctorOfProviderInput;
  doctorId: Scalars['String'];
};


export type MutationAdminUpdatePartnerContactLogArgs = {
  comment?: InputMaybe<Scalars['String']>;
  contactLogId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
  fileRemoved?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAdminUpdatePatientArgs = {
  address?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['DateTime']>;
  children?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isObsolete?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  newsOffersNotification?: InputMaybe<Scalars['Boolean']>;
  postalCode?: InputMaybe<Scalars['String']>;
  primaryContactNo?: InputMaybe<Scalars['String']>;
  renewalNotification?: InputMaybe<Scalars['String']>;
  secondaryContactNo?: InputMaybe<Scalars['String']>;
  spouse?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type MutationAdminUpdatePatientContactLogArgs = {
  comment?: InputMaybe<Scalars['String']>;
  contactLogId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
};


export type MutationAdminUpdatePromoCodeArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['Float']>;
  code?: InputMaybe<Scalars['String']>;
  days?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<Scalars['String']>;
  enable?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Float']>;
  note?: InputMaybe<Scalars['String']>;
  promocodeId: Scalars['String'];
};


export type MutationAdminUpdateProviderArgs = {
  data: AdminUpdateProviderInput;
  providerId: Scalars['String'];
};


export type MutationAdminUpdateProviderContactLogArgs = {
  comment?: InputMaybe<Scalars['String']>;
  contactLogId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
};


export type MutationChangeMyProviderArgs = {
  providerId: Scalars['String'];
};


export type MutationGetActivityReportArgs = {
  eEnd: Scalars['String'];
  eStart: Scalars['String'];
  fEnd: Scalars['String'];
  fStart: Scalars['String'];
};


export type MutationGetDepositReportArgs = {
  fEnd: Scalars['String'];
  fStart: Scalars['String'];
};


export type MutationGetPaymentLinkForAdminArgs = {
  patientId: Scalars['String'];
};


export type MutationGetPublicPaymentLinkArgs = {
  email?: InputMaybe<Scalars['String']>;
  lastname: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
};


export type MutationGetReportViewActionArgs = {
  reportId: Scalars['String'];
};


export type MutationPartnerSignUpArgs = {
  address: Scalars['String'];
  agent: Scalars['String'];
  bankACNumber?: InputMaybe<Scalars['String']>;
  bankRoutingNumber?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  companyName: Scalars['String'];
  currentNoOfEmployees?: InputMaybe<Scalars['Float']>;
  email: Scalars['String'];
  logo?: InputMaybe<Scalars['Upload']>;
  phoneNumber: Scalars['String'];
  planPurchase?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  state: Scalars['String'];
  type: Scalars['String'];
  w9Form?: InputMaybe<Scalars['Upload']>;
  website: Scalars['String'];
};


export type MutationPatieentUpdatePaperRenewalNotificationStateArgs = {
  renewalNotificationState: Scalars['String'];
};


export type MutationPatientBulkUploadArgs = {
  file?: InputMaybe<Scalars['Upload']>;
  generatePromoCode?: InputMaybe<Scalars['Boolean']>;
  providerId: Scalars['String'];
};


export type MutationPatientCancelPlanArgs = {
  needRefund?: InputMaybe<Scalars['Boolean']>;
  subscriptionId: Scalars['String'];
};


export type MutationPatientCancelPlanMessageArgs = {
  subscriptionId: Scalars['String'];
};


export type MutationPatientChangeEmailArgs = {
  newEmail: Scalars['String'];
};


export type MutationPatientLoginArgs = {
  email: Scalars['String'];
};


export type MutationPatientLoginWithOtpArgs = {
  email: Scalars['String'];
  otp: Scalars['String'];
};


export type MutationPatientRecoverAccountArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  memberId: Scalars['String'];
  newEmail: Scalars['String'];
  zipcode: Scalars['String'];
};


export type MutationPatientResendLoginOtpArgs = {
  email: Scalars['String'];
};


export type MutationPatientSignupArgs = {
  address: Scalars['String'];
  backdate?: InputMaybe<Scalars['DateTime']>;
  birthDate: Scalars['DateTime'];
  children?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  newsOffersNotification: Scalars['Boolean'];
  postalCode: Scalars['String'];
  primaryContactNo: Scalars['String'];
  providerId: Scalars['String'];
  referralCode?: InputMaybe<Scalars['String']>;
  renewalNotification: Scalars['String'];
  secondaryContactNo?: InputMaybe<Scalars['String']>;
  spouse?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
};


export type MutationPatientUpdateNewsOfferStateArgs = {
  NewsOfferState: Scalars['Boolean'];
};


export type MutationPatientUpdateProfileArgs = {
  address?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['DateTime']>;
  children?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  primaryContactNo?: InputMaybe<Scalars['String']>;
  secondaryContactNo?: InputMaybe<Scalars['String']>;
  spouse?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


export type MutationPatientVerifyOtpArgs = {
  email: Scalars['String'];
  otp: Scalars['String'];
};


export type MutationProviderLoginArgs = {
  email: Scalars['String'];
};


export type MutationProviderLoginWithOtpArgs = {
  email: Scalars['String'];
  otp: Scalars['String'];
};


export type MutationProviderRecoverAccountArgs = {
  lic: Scalars['String'];
  name: Scalars['String'];
  newEmail: Scalars['String'];
  providerid: Scalars['String'];
};


export type MutationProviderResendLoginOtpArgs = {
  email: Scalars['String'];
};


export type MutationProviderSignupArgs = {
  birthDate: Scalars['DateTime'];
  city: Scalars['String'];
  clinicAddress: Scalars['String'];
  doctors?: InputMaybe<Array<DoctorType>>;
  email: Scalars['String'];
  fax?: InputMaybe<Scalars['String']>;
  firstname: Scalars['String'];
  isSwitchType: Scalars['Boolean'];
  lastname: Scalars['String'];
  limitsOfLiability: Scalars['String'];
  mailAddress?: InputMaybe<Scalars['String']>;
  mailCity?: InputMaybe<Scalars['String']>;
  mailPostalCode?: InputMaybe<Scalars['String']>;
  mailState?: InputMaybe<Scalars['String']>;
  malpracticeInsuranceNumber: Scalars['String'];
  officeHours?: InputMaybe<Scalars['String']>;
  onBoardReferralCode?: InputMaybe<Scalars['String']>;
  onReferralName?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  postalCode: Scalars['String'];
  practiceName: Scalars['String'];
  sameMailingAddress: Scalars['Boolean'];
  socialMediaHandles?: InputMaybe<Array<SocialMediaType>>;
  staffEmail?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  stateLicenseNumber: Scalars['String'];
  taxIDNumber: Scalars['String'];
  training: Scalars['Boolean'];
  website?: InputMaybe<Scalars['String']>;
};


export type MutationProviderUpdateAssociateProfileArgs = {
  data: UpdateDoctorOfProviderInput;
  doctorId: Scalars['String'];
};


export type MutationProviderUpdateDetailsArgs = {
  data: UpdateProviderInput;
};


export type MutationPublicSubscribeToPlanArgs = {
  appliedPromoCode?: InputMaybe<Scalars['String']>;
  planId: Scalars['String'];
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type MutationPublicSubscribeToPlanWithTokenArgs = {
  appliedPromoCode?: InputMaybe<Scalars['String']>;
  planId: Scalars['String'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  token: Scalars['String'];
};


export type MutationPublicVerifyPaymentArgs = {
  subcriptionId: Scalars['String'];
};


export type MutationPublicVerifyPaymentWithTokenArgs = {
  subcriptionId: Scalars['String'];
  token: Scalars['String'];
};

export type Patient = {
  __typename?: 'Patient';
  _count?: Maybe<PatientCount>;
  address: Scalars['String'];
  automaticRenewal: Scalars['Boolean'];
  birthDate?: Maybe<Scalars['DateTime']>;
  children?: Maybe<Scalars['JSON']>;
  city: Scalars['String'];
  comments: Scalars['String'];
  created_at: Scalars['DateTime'];
  email: Scalars['String'];
  emailLower: Scalars['String'];
  enable: Scalars['Boolean'];
  expires_at?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  firstNameLower: Scalars['String'];
  id: Scalars['String'];
  idCardNumber?: Maybe<Scalars['String']>;
  idCardNumberNum?: Maybe<Scalars['Int']>;
  isMasterPatient: Scalars['Boolean'];
  isOnBoardEmailSent: Scalars['Boolean'];
  lastName: Scalars['String'];
  lastNameLower: Scalars['String'];
  manualStartDate?: Maybe<Scalars['DateTime']>;
  newsOffersNotification: Scalars['Boolean'];
  oldIdCardNumber?: Maybe<Scalars['String']>;
  oldPatientId?: Maybe<Scalars['String']>;
  oldProviderId?: Maybe<Scalars['String']>;
  originalStatus?: Maybe<Scalars['String']>;
  patientStripeId: Scalars['String'];
  paymentMethodUpdates?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  primaryContactNo: Scalars['String'];
  providerId?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
  renewalNotification: RenewalNotificationType;
  secondaryContactNo: Scalars['String'];
  spouse?: Maybe<Scalars['JSON']>;
  state: Scalars['String'];
  status?: Maybe<PatientStatus>;
  tokenVersion: Scalars['Int'];
  type: PatientType;
  updated_at: Scalars['DateTime'];
};

export type PatientCount = {
  __typename?: 'PatientCount';
  contactLogs: Scalars['Int'];
  patientPlan: Scalars['Int'];
};

export type PatientLoginOtpResponse = {
  __typename?: 'PatientLoginOTPResponse';
  data?: Maybe<Patient>;
  token: Scalars['String'];
};

export type PatientPlan = {
  __typename?: 'PatientPlan';
  created_at: Scalars['DateTime'];
  end_date?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  patientId: Scalars['String'];
  paymentId?: Maybe<Scalars['String']>;
  planId: Scalars['String'];
  start_date?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PatientPlanStatus>;
  stripeSubscriptionId: Scalars['String'];
};

export type PatientPlanResponse = {
  __typename?: 'PatientPlanResponse';
  created_at: Scalars['DateTime'];
  end_date?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isRenewable?: Maybe<Scalars['Boolean']>;
  patientId: Scalars['String'];
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['String']>;
  plan?: Maybe<PaymentPlan>;
  planId: Scalars['String'];
  start_date?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PatientPlanStatus>;
  stripeSubscriptionId: Scalars['String'];
};

export enum PatientPlanStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Incomplete = 'INCOMPLETE'
}

export type PatientQuickLookupResponse = {
  __typename?: 'PatientQuickLookupResponse';
  address: Scalars['String'];
  backdate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  memberId: Scalars['String'];
  planDetails: Scalars['String'];
  providerDetails: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  ucEndDate?: Maybe<Scalars['DateTime']>;
  ucStartDate?: Maybe<Scalars['DateTime']>;
  upcomingPlanDetails?: Maybe<Scalars['String']>;
};

export enum PatientStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Expired = 'Expired',
  Expiring = 'Expiring',
  FirstYear = 'FirstYear',
  Free = 'Free',
  Obsolete = 'Obsolete',
  Pending = 'Pending',
  Prospect = 'Prospect',
  Renewed = 'Renewed',
  Upgraded = 'Upgraded'
}

export enum PatientType {
  Family = 'Family',
  Individual = 'Individual',
  Pcd = 'PCD',
  Prospect = 'Prospect'
}

export type PatientWithStripeSession = {
  __typename?: 'PatientWithStripeSession';
  _count?: Maybe<PatientCount>;
  address: Scalars['String'];
  automaticRenewal: Scalars['Boolean'];
  birthDate?: Maybe<Scalars['DateTime']>;
  children?: Maybe<Scalars['JSON']>;
  city: Scalars['String'];
  comments: Scalars['String'];
  created_at: Scalars['DateTime'];
  email: Scalars['String'];
  emailLower: Scalars['String'];
  enable: Scalars['Boolean'];
  expires_at?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  firstNameLower: Scalars['String'];
  id: Scalars['String'];
  idCardNumber?: Maybe<Scalars['String']>;
  idCardNumberNum?: Maybe<Scalars['Int']>;
  isMasterPatient: Scalars['Boolean'];
  isOnBoardEmailSent: Scalars['Boolean'];
  lastName: Scalars['String'];
  lastNameLower: Scalars['String'];
  manualStartDate?: Maybe<Scalars['DateTime']>;
  newsOffersNotification: Scalars['Boolean'];
  oldIdCardNumber?: Maybe<Scalars['String']>;
  oldPatientId?: Maybe<Scalars['String']>;
  oldProviderId?: Maybe<Scalars['String']>;
  originalStatus?: Maybe<Scalars['String']>;
  patientStripeId: Scalars['String'];
  paymentMethodUpdates?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  primaryContactNo: Scalars['String'];
  providerId?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
  renewalNotification: RenewalNotificationType;
  secondaryContactNo: Scalars['String'];
  spouse?: Maybe<Scalars['JSON']>;
  state: Scalars['String'];
  status?: Maybe<PatientStatus>;
  stripePortalURL?: Maybe<Scalars['String']>;
  tokenVersion: Scalars['Int'];
  type: PatientType;
  updated_at: Scalars['DateTime'];
};

export type Payment = {
  __typename?: 'Payment';
  _count?: Maybe<PaymentCount>;
  amount: Scalars['Float'];
  created_at: Scalars['DateTime'];
  extraNote: Scalars['String'];
  id: Scalars['String'];
  paymentGatewayId: Scalars['String'];
  paymentType: PaymentType;
  status: PaymentStatus;
};

export type PaymentCount = {
  __typename?: 'PaymentCount';
  PatientPlan: Scalars['Int'];
};

export type PaymentPlan = {
  __typename?: 'PaymentPlan';
  _count?: Maybe<PaymentPlanCount>;
  amount: Scalars['Float'];
  applicableStates: Array<Scalars['String']>;
  created_at: Scalars['DateTime'];
  description: Scalars['String'];
  durationText: Scalars['String'];
  enable: Scalars['Boolean'];
  id: Scalars['String'];
  isFree?: Maybe<Scalars['Boolean']>;
  isRecurring: Scalars['Boolean'];
  listOrder: Scalars['Int'];
  planName: Scalars['String'];
  stripePlanId: Scalars['String'];
};

export type PaymentPlanCount = {
  __typename?: 'PaymentPlanCount';
  PatientPlan: Scalars['Int'];
};

export enum PaymentStatus {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export enum PaymentType {
  ApplePay = 'APPLE_PAY',
  Card = 'CARD',
  CashAppPay = 'CASH_APP_PAY',
  ECheque = 'E_CHEQUE',
  GooglePay = 'GOOGLE_PAY',
  Manual = 'MANUAL',
  Unknown = 'UNKNOWN'
}

export type PromoCode = {
  __typename?: 'PromoCode';
  active: Scalars['Boolean'];
  amount?: Maybe<Scalars['Float']>;
  code: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by: Scalars['String'];
  days?: Maybe<Scalars['Int']>;
  discountType: PromoCodeDiscountType;
  enable: Scalars['Boolean'];
  expiryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  limit: Scalars['Int'];
  noOfTimesUsed: Scalars['Int'];
  note: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  stripePromocodeId: Scalars['String'];
  updated_at: Scalars['DateTime'];
  updated_by: Scalars['String'];
};

export enum PromoCodeDiscountType {
  AmountDiscount = 'AMOUNT_DISCOUNT',
  Percentage = 'PERCENTAGE',
  SubscriptionDays = 'SUBSCRIPTION_DAYS'
}

export type Provider = {
  __typename?: 'Provider';
  _count?: Maybe<ProviderCount>;
  birthDate?: Maybe<Scalars['DateTime']>;
  city: Scalars['String'];
  clinicAddress: Scalars['String'];
  comments: Scalars['String'];
  contactName: Scalars['String'];
  created_at: Scalars['DateTime'];
  doctorLocatorEnable: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  enable: Scalars['Boolean'];
  enrollmentType: ProviderEnrollmentType;
  fax: Scalars['String'];
  firstname: Scalars['String'];
  googleMapPlaceId: Scalars['String'];
  id: Scalars['String'];
  lastname: Scalars['String'];
  limitsOfLiability: Scalars['String'];
  mailAddress: Scalars['String'];
  mailCity: Scalars['String'];
  mailPostalCode: Scalars['String'];
  mailState: Scalars['String'];
  malpracticeInsuranceNumber: Scalars['String'];
  noPatientRenewal: Scalars['Boolean'];
  officeHours: Scalars['String'];
  oldMemberNumber?: Maybe<Scalars['String']>;
  oldProviderId: Scalars['String'];
  onBoardReferralCode: Scalars['String'];
  onReferralName: Scalars['String'];
  phoneNumber: Scalars['String'];
  postalCode: Scalars['String'];
  practiceName: Scalars['String'];
  practiceNameLower: Scalars['String'];
  promoCode: Scalars['String'];
  providerId: Scalars['String'];
  providerIdNum?: Maybe<Scalars['Int']>;
  staffEmail: Scalars['String'];
  state: Scalars['String'];
  stateLicenseNumber: Scalars['String'];
  status?: Maybe<ProviderStatus>;
  taxIDNumber: Scalars['String'];
  tokenVersion: Scalars['Int'];
  updated_at: Scalars['DateTime'];
  website: Scalars['String'];
};

export type ProviderCount = {
  __typename?: 'ProviderCount';
  chiropractors: Scalars['Int'];
  contactLog: Scalars['Int'];
  patient: Scalars['Int'];
  socialMediaHandles: Scalars['Int'];
};

export enum ProviderEnrollmentType {
  Standard = 'STANDARD',
  Switch = 'SWITCH'
}

export type ProviderListResponse = {
  __typename?: 'ProviderListResponse';
  distance?: Maybe<Scalars['Float']>;
  provider: Provider;
};

export type ProviderLoginOtpResponse = {
  __typename?: 'ProviderLoginOTPResponse';
  data?: Maybe<Provider>;
  token: Scalars['String'];
};

export type ProviderMeRes = {
  __typename?: 'ProviderMeRes';
  _count?: Maybe<ProviderCount>;
  birthDate?: Maybe<Scalars['DateTime']>;
  chiropractors: Array<Doctor>;
  city: Scalars['String'];
  clinicAddress: Scalars['String'];
  comments: Scalars['String'];
  contactLog: Array<ContactLog>;
  contactName: Scalars['String'];
  created_at: Scalars['DateTime'];
  doctorLocatorEnable: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  enable: Scalars['Boolean'];
  enrollmentType: ProviderEnrollmentType;
  fax: Scalars['String'];
  firstname: Scalars['String'];
  googleMapPlaceId: Scalars['String'];
  id: Scalars['String'];
  lastname: Scalars['String'];
  limitsOfLiability: Scalars['String'];
  mailAddress: Scalars['String'];
  mailCity: Scalars['String'];
  mailPostalCode: Scalars['String'];
  mailState: Scalars['String'];
  malpracticeInsuranceNumber: Scalars['String'];
  noPatientRenewal: Scalars['Boolean'];
  officeHours: Scalars['String'];
  oldMemberNumber?: Maybe<Scalars['String']>;
  oldProviderId: Scalars['String'];
  onBoardReferralCode: Scalars['String'];
  onReferralName: Scalars['String'];
  phoneNumber: Scalars['String'];
  postalCode: Scalars['String'];
  practiceName: Scalars['String'];
  practiceNameLower: Scalars['String'];
  promoCode: Scalars['String'];
  providerId: Scalars['String'];
  providerIdNum?: Maybe<Scalars['Int']>;
  socialMediaHandles: Array<SocialMedia>;
  staffEmail: Scalars['String'];
  state: Scalars['String'];
  stateLicenseNumber: Scalars['String'];
  status?: Maybe<ProviderStatus>;
  taxIDNumber: Scalars['String'];
  tokenVersion: Scalars['Int'];
  updated_at: Scalars['DateTime'];
  website: Scalars['String'];
};

export type ProviderPatientListResponse = {
  __typename?: 'ProviderPatientListResponse';
  patientList: Array<ProviderPatientWithPlan>;
  totalCount: Scalars['Float'];
};

export type ProviderPatientWithPlan = {
  __typename?: 'ProviderPatientWithPlan';
  _count?: Maybe<PatientCount>;
  address: Scalars['String'];
  automaticRenewal: Scalars['Boolean'];
  birthDate?: Maybe<Scalars['DateTime']>;
  children?: Maybe<Scalars['JSON']>;
  city: Scalars['String'];
  comments: Scalars['String'];
  created_at: Scalars['DateTime'];
  email: Scalars['String'];
  emailLower: Scalars['String'];
  enable: Scalars['Boolean'];
  expires_at?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  firstNameLower: Scalars['String'];
  id: Scalars['String'];
  idCardNumber?: Maybe<Scalars['String']>;
  idCardNumberNum?: Maybe<Scalars['Int']>;
  isMasterPatient: Scalars['Boolean'];
  isOnBoardEmailSent: Scalars['Boolean'];
  lastName: Scalars['String'];
  lastNameLower: Scalars['String'];
  manualStartDate?: Maybe<Scalars['DateTime']>;
  newsOffersNotification: Scalars['Boolean'];
  oldIdCardNumber?: Maybe<Scalars['String']>;
  oldPatientId?: Maybe<Scalars['String']>;
  oldProviderId?: Maybe<Scalars['String']>;
  originalStatus?: Maybe<Scalars['String']>;
  patientPlan: Array<PatientPlan>;
  patientStripeId: Scalars['String'];
  paymentMethodUpdates?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  primaryContactNo: Scalars['String'];
  providerId?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
  renewalNotification: RenewalNotificationType;
  secondaryContactNo: Scalars['String'];
  spouse?: Maybe<Scalars['JSON']>;
  state: Scalars['String'];
  status?: Maybe<PatientStatus>;
  tokenVersion: Scalars['Int'];
  type: PatientType;
  updated_at: Scalars['DateTime'];
};

export type ProviderPatientsCountResponse = {
  __typename?: 'ProviderPatientsCountResponse';
  activePatientsCount: Scalars['Float'];
  expiredPatientsCount: Scalars['Float'];
  pendingPatientsCount: Scalars['Float'];
  totalCount: Scalars['Float'];
};

export type ProviderSocialMediaInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export enum ProviderStatus {
  Active = 'ACTIVE',
  Chiropractor = 'CHIROPRACTOR',
  Deactivate = 'DEACTIVATE',
  Enrolled = 'ENROLLED',
  Implemented = 'IMPLEMENTED',
  Inactive = 'INACTIVE',
  Obsolete = 'OBSOLETE',
  Prospect = 'PROSPECT'
}

export type PublicSubsribeToPlanResponse = {
  __typename?: 'PublicSubsribeToPlanResponse';
  clientSecret?: Maybe<Scalars['String']>;
  subscriptionId: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  AdminPatientGetBillingHistory: Scalars['String'];
  AdminPatientGetCurrentPlanInfo?: Maybe<Array<AdminPatientPlanResponse>>;
  AdminPatientGetHistoricalPlanList: Array<AdminPatientHistoricalPlanResponse>;
  PatientGetHistoricalPlanList: Array<PatientPlanResponse>;
  adminGetAnnouncementById: Message;
  adminGetPartnerById: AffiliatePartner;
  adminGetPatientById: AdminPatientListItem;
  adminGetPromoCodeUsedNumber: Scalars['Float'];
  adminGetProviderById: AdminSingleProviderResponse;
  adminListAnnouncements: AdminMessageListResponse;
  adminListMember: Array<Admin>;
  adminListPartnerContactLog: Array<ContactLog>;
  adminListPartners: AdminPartnersListResponse;
  adminListPatient: AdminPatientListResponse;
  adminListPatientContactLog: Array<ContactLog>;
  adminListPromoCode: Array<PromoCode>;
  adminListProvider: AdminProviderListResponse;
  adminListProviderContactLog: Array<ContactLog>;
  adminListReport: AdminReportListResponse;
  adminMe: Admin;
  adminPatientsCount: AdminPatientCountResponse;
  checkPromocode: PromoCode;
  getMyPatientsListReport: Scalars['Boolean'];
  getPatientQuickLookup: Array<PatientQuickLookupResponse>;
  getPatientsListReport: Scalars['Boolean'];
  getProvidersListReport: Scalars['Boolean'];
  getReportById: Report;
  patientAddressCheck: Scalars['Boolean'];
  patientBlogs: Scalars['String'];
  patientGetAnnouncements: Array<Message>;
  patientGetBillingHistory: Scalars['String'];
  patientGetCurrentPlanInfo?: Maybe<PatientPlanResponse>;
  patientGetCurrentPlanInfos: Array<PatientPlanResponse>;
  patientGetMemberCardInfo: MemberCardInfoResponse;
  patientGetMyProviderInfo: Provider;
  patientGetProviderById: ProviderListResponse;
  patientGetProviderList: Array<ProviderListResponse>;
  patientGetShareableIDCardLink: Scalars['String'];
  patientMe: PatientWithStripeSession;
  providerBlogs: Scalars['String'];
  providerGetAnnouncements: Array<Message>;
  providerGetMyPatientById: Patient;
  providerGetMyPatientList: ProviderPatientListResponse;
  providerListReport: Array<Report>;
  providerMe: ProviderMeRes;
  providerPatientsCount: ProviderPatientsCountResponse;
  publicGetProviderProfileInfo: DoctorLocatorProviderFullRes;
  publicListPlans: Array<PaymentPlan>;
  publicLocateProviderList: Array<DoctorLocatorProviderListResponse>;
  test: Scalars['String'];
};


export type QueryAdminPatientGetBillingHistoryArgs = {
  patientId: Scalars['String'];
};


export type QueryAdminPatientGetCurrentPlanInfoArgs = {
  patientId: Scalars['String'];
};


export type QueryAdminPatientGetHistoricalPlanListArgs = {
  patientId: Scalars['String'];
};


export type QueryAdminGetAnnouncementByIdArgs = {
  id: Scalars['String'];
};


export type QueryAdminGetPartnerByIdArgs = {
  partnerId: Scalars['String'];
};


export type QueryAdminGetPatientByIdArgs = {
  patientId: Scalars['String'];
};


export type QueryAdminGetPromoCodeUsedNumberArgs = {
  promocodeId: Scalars['String'];
};


export type QueryAdminGetProviderByIdArgs = {
  providerId: Scalars['String'];
};


export type QueryAdminListPartnerContactLogArgs = {
  partnerId: Scalars['String'];
};


export type QueryAdminListPartnersArgs = {
  currentPageIndex: Scalars['Float'];
  filters: PartnerFiltersType;
  itemsCountPerPage: Scalars['Float'];
};


export type QueryAdminListPatientArgs = {
  currentPageIndex: Scalars['Float'];
  filters: FiltersType;
  itemsCountPerPage: Scalars['Float'];
};


export type QueryAdminListPatientContactLogArgs = {
  patientId: Scalars['String'];
};


export type QueryAdminListProviderArgs = {
  activeProvidersOnly?: InputMaybe<Scalars['Boolean']>;
  currentPageIndex: Scalars['Float'];
  filters: ProviderFiltersType;
  itemsCountPerPage: Scalars['Float'];
};


export type QueryAdminListProviderContactLogArgs = {
  providerId: Scalars['String'];
};


export type QueryAdminListReportArgs = {
  currentPageIndex: Scalars['Float'];
  itemsCountPerPage: Scalars['Float'];
};


export type QueryCheckPromocodeArgs = {
  promocode: Scalars['String'];
};


export type QueryGetMyPatientsListReportArgs = {
  dateRangeToInclude?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetPatientQuickLookupArgs = {
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  memberId?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};


export type QueryGetPatientsListReportArgs = {
  dateRangeToInclude?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  selectedFields: Array<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetProvidersListReportArgs = {
  dateRangeToInclude?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetReportByIdArgs = {
  reportId: Scalars['String'];
};


export type QueryPatientAddressCheckArgs = {
  address: Scalars['String'];
};


export type QueryPatientGetMemberCardInfoArgs = {
  tokenId: Scalars['String'];
};


export type QueryPatientGetProviderByIdArgs = {
  providerId: Scalars['String'];
};


export type QueryPatientGetProviderListArgs = {
  city?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


export type QueryProviderGetMyPatientByIdArgs = {
  patientId: Scalars['String'];
};


export type QueryProviderGetMyPatientListArgs = {
  currentPageIndex: Scalars['Float'];
  filters: ProviderPatientFiltersType;
  itemsCountPerPage: Scalars['Float'];
};


export type QueryPublicGetProviderProfileInfoArgs = {
  providerId: Scalars['String'];
};


export type QueryPublicLocateProviderListArgs = {
  city?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export enum RenewalNotificationType {
  None = 'NONE',
  Paper = 'PAPER',
  Paperless = 'PAPERLESS'
}

export type Report = {
  __typename?: 'Report';
  created_at: Scalars['DateTime'];
  data: Array<Scalars['JSON']>;
  filepath: Array<Scalars['String']>;
  id: Scalars['String'];
  recipients: Array<Scalars['String']>;
  reportName: Scalars['String'];
  reportType: ReportTypes;
  status: ReportStatus;
};

export enum ReportStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export enum ReportTypes {
  AccessOne = 'ACCESS_ONE',
  ActivityReport = 'ACTIVITY_REPORT',
  MondayReport = 'MONDAY_REPORT',
  PatientList = 'PATIENT_LIST',
  PatientRenewals = 'PATIENT_RENEWALS',
  ProviderList = 'PROVIDER_LIST',
  ProviderReport = 'PROVIDER_REPORT',
  ProviderStats = 'PROVIDER_STATS',
  RenewalFinal = 'RENEWAL_FINAL'
}

export type SocialMedia = {
  __typename?: 'SocialMedia';
  id: Scalars['String'];
  name: SocialMediaTypes;
  providerId: Scalars['String'];
  url: Scalars['String'];
};

export type SocialMediaInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type SocialMediaType = {
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export enum SocialMediaTypes {
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  LinkedIn = 'LinkedIn',
  Twitter = 'Twitter'
}

export type SubsribeToPlanResponse = {
  __typename?: 'SubsribeToPlanResponse';
  clientSecret?: Maybe<Scalars['String']>;
  subscriptionId: Scalars['String'];
};

export type UpdateDoctorOfProviderInput = {
  additionalComments?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['DateTime']>;
  certificates?: InputMaybe<Scalars['String']>;
  colleges?: InputMaybe<Scalars['String']>;
  diagnostics?: InputMaybe<Scalars['String']>;
  doYouOffer?: InputMaybe<Scalars['String']>;
  fees?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  hours?: InputMaybe<Scalars['String']>;
  modalities?: InputMaybe<Scalars['String']>;
  techniques?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateProviderInput = {
  city?: InputMaybe<Scalars['String']>;
  clinicAddress?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  enable?: InputMaybe<Scalars['Boolean']>;
  enrollmentType?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  googleMapPlaceId?: InputMaybe<Scalars['String']>;
  limitsOfLiability?: InputMaybe<Scalars['String']>;
  mailAddress?: InputMaybe<Scalars['String']>;
  mailCity?: InputMaybe<Scalars['String']>;
  mailPostalCode?: InputMaybe<Scalars['String']>;
  mailState?: InputMaybe<Scalars['String']>;
  malpracticeInsuranceNumber?: InputMaybe<Scalars['String']>;
  noPaitentRenewal?: InputMaybe<Scalars['Boolean']>;
  officeHours?: InputMaybe<Scalars['String']>;
  onBoardReferralCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  practiceName?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<Scalars['String']>;
  socialMediaHandles?: InputMaybe<Array<ProviderSocialMediaInput>>;
  staffEmail?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  stateLicenseNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  taxIDNumber?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type FiltersType = {
  city?: InputMaybe<Scalars['String']>;
  oldPatientId?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  searchField?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type PartnerFiltersType = {
  searchTerm?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ProviderFiltersType = {
  city?: InputMaybe<Scalars['String']>;
  enrollmentType?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type ProviderPatientFiltersType = {
  city?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type PublicListPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicListPlansQuery = { __typename?: 'Query', publicListPlans: Array<{ __typename?: 'PaymentPlan', id: string, planName: string, amount: number, description: string, created_at: any, applicableStates: Array<string>, enable: boolean, stripePlanId: string, durationText: string, listOrder: number }> };

export type PublicLocateProviderListQueryVariables = Exact<{
  postalCode?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
}>;


export type PublicLocateProviderListQuery = { __typename?: 'Query', publicLocateProviderList: Array<{ __typename?: 'DoctorLocatorProviderListResponse', distance?: number | null, provider: { __typename?: 'Provider', id: string, providerId: string, practiceName: string, mailAddress: string, mailCity: string, mailState: string, mailPostalCode: string, googleMapPlaceId: string, website: string } }> };

export type PublicGetProviderProfileInfoQueryVariables = Exact<{
  providerId: Scalars['String'];
}>;


export type PublicGetProviderProfileInfoQuery = { __typename?: 'Query', publicGetProviderProfileInfo: { __typename?: 'DoctorLocatorProviderFullRes', id: string, providerId: string, practiceName: string, phoneNumber: string, fax: string, officeHours: string, mailAddress: string, mailCity: string, mailState: string, mailPostalCode: string, googleMapPlaceId: string, website: string, chiropractors: Array<{ __typename?: 'Doctor', id: string, fullName: string, providerId: string, oldProviderId: string, website: string, birthDate?: any | null, isPrimary: boolean, hours?: string | null, colleges?: string | null, certificates?: string | null, diagnostics?: string | null, modalities?: string | null, doYouOffer?: string | null, techniques?: string | null, fees?: string | null, additionalComments: string }>, socialMediaHandles: Array<{ __typename?: 'SocialMedia', id: string, name: SocialMediaTypes, url: string, providerId: string }> } };


export const PublicListPlansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"publicListPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicListPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planName"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"applicableStates"}},{"kind":"Field","name":{"kind":"Name","value":"enable"}},{"kind":"Field","name":{"kind":"Name","value":"stripePlanId"}},{"kind":"Field","name":{"kind":"Name","value":"durationText"}},{"kind":"Field","name":{"kind":"Name","value":"listOrder"}}]}}]}}]} as unknown as DocumentNode<PublicListPlansQuery, PublicListPlansQueryVariables>;
export const PublicLocateProviderListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"publicLocateProviderList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicLocateProviderList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"practiceName"}},{"kind":"Field","name":{"kind":"Name","value":"mailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"mailCity"}},{"kind":"Field","name":{"kind":"Name","value":"mailState"}},{"kind":"Field","name":{"kind":"Name","value":"mailPostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"googleMapPlaceId"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}},{"kind":"Field","name":{"kind":"Name","value":"distance"}}]}}]}}]} as unknown as DocumentNode<PublicLocateProviderListQuery, PublicLocateProviderListQueryVariables>;
export const PublicGetProviderProfileInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"publicGetProviderProfileInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicGetProviderProfileInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"providerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"practiceName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"officeHours"}},{"kind":"Field","name":{"kind":"Name","value":"mailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"mailCity"}},{"kind":"Field","name":{"kind":"Name","value":"mailState"}},{"kind":"Field","name":{"kind":"Name","value":"mailPostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"googleMapPlaceId"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"chiropractors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"oldProviderId"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"birthDate"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"colleges"}},{"kind":"Field","name":{"kind":"Name","value":"certificates"}},{"kind":"Field","name":{"kind":"Name","value":"diagnostics"}},{"kind":"Field","name":{"kind":"Name","value":"modalities"}},{"kind":"Field","name":{"kind":"Name","value":"doYouOffer"}},{"kind":"Field","name":{"kind":"Name","value":"techniques"}},{"kind":"Field","name":{"kind":"Name","value":"fees"}},{"kind":"Field","name":{"kind":"Name","value":"additionalComments"}}]}},{"kind":"Field","name":{"kind":"Name","value":"socialMediaHandles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}}]}}]}}]}}]} as unknown as DocumentNode<PublicGetProviderProfileInfoQuery, PublicGetProviderProfileInfoQueryVariables>;